import errorIcon from "../Assets/Images/error.png";
import { getActivePrestationBrandConfig } from "../config/environment.config";

const validateMultiStep = (value: { fr_FR?: string } | null | undefined) => {
    if (!value || !value?.fr_FR) {
        return {
            isValid: false,
            message: `Sélectionnez un ${getActivePrestationBrandConfig('','un ',"une ")}`,
            icon: <img src={errorIcon} alt="" className="w-4 h-4 translate-y-1" />,
        };
    } else
        return {
            isValid: true,
            message: "",
            icon: "",
        };
};

export default validateMultiStep;
